import React from "react";
import {AboutMeWrapper} from "./AboutMeElements";

const AboutMe = () => {
    return <>
        <AboutMeWrapper>
            <h1 id='about'>About me</h1>
        </AboutMeWrapper>

    </>
}

export default AboutMe;
